const items = [
  "WCAG-aligned",
  "Works on any website",
  "Keyboard & voice ready",
  "Screen reader friendly",
  "Low cognitive load",
  "Private by default",
  "Open to builders",
];

const Marquee = () => {
  return (
    <section
      data-testid="marquee-section"
      className="relative py-10 border-y border-white/[0.06] bg-[#070707]/60"
    >
      <div className="marquee-fade overflow-hidden">
        <div className="flex gap-12 animate-[scroll_38s_linear_infinite] whitespace-nowrap">
          {[...items, ...items, ...items].map((item, i) => (
            <div
              key={i}
              className="flex items-center gap-3 font-mono text-[11px] uppercase tracking-[0.2em] text-zinc-500"
            >
              <span className="h-1 w-1 rounded-full bg-indigo-500/60" />
              {item}
            </div>
          ))}
        </div>
      </div>

      <style>{`
        @keyframes scroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(-33.3333%); }
        }
      `}</style>
    </section>
  );
};

export default Marquee;
